import React, { memo, forwardRef } from "react";
const SvgShiftFill = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M8.246 14.433l6.993-8.087a1 1 0 011.513 0l6.993 8.087a1 1 0 01-.756 1.654h-2.993v7.932a1 1 0 01-1 1h-6a1 1 0 01-1-1v-7.932H9.002a1 1 0 01-.756-1.654z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgShiftFill.displayName = "SvgShiftFill";
const MemoForwardRef = memo(SvgShiftFill);
export default MemoForwardRef;
